import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const [azureBatchSizeError, setAzureBatchSizeError] = useState(false);
  const [azureWaitTimeError, setAzureWaitTimeError] = useState(false);
  const { azureBatchSize, azureWaitTime, contentTypes } = formData;
  const availableContent = [
    { label: t("azure.content_types.azure_services"), value: "AZURE_SERVICES" },
    { label: t("azure.content_types.json_array"), value: "JSON_ARRAY" },
    { label: t("azure.content_types.raw_text"), value: "TEXT" },
    { label: t("azure.content_types.gelf_batch"), value: "GELF_BATCH" },
    { label: t("azure.content_types.text_batch"), value: "TEXT_BATCH" }
  ];
  const [contentTypesState, setContentTypesState] = useState(contentTypes.value || "");
  const [contentTypeVal] = useState(false);
  const handleSubmit = () => {
    formData.contentTypes.value = contentTypesState;
    let error = false;
    if (azureBatchSize.value < 1 || azureBatchSize.value > 1e3) {
      error = true;
      setAzureBatchSizeError(true);
    }
    if (azureWaitTime.value < 1 || azureWaitTime.value > 30) {
      error = true;
      setAzureWaitTimeError(true);
    }
    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("azure.fields.content_type")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        name: "content_types",
        id: "contentTypes",
        onChange: (selected) => setContentTypesState(selected),
        options: availableContent,
        value: contentTypesState || ""
      }
    ),
    contentTypeVal && contentTypesState.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes" }, t("azure.fields.select_at_least_one")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("azure.fields.content_type_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "azureBatchSize",
        name: "azureBatchSize",
        type: "number",
        value: azureBatchSize.value || azureBatchSize.defaultValue || "",
        min: "10",
        max: "20000",
        onChange,
        required: true,
        help: t("azure.fields.batch_size_help"),
        label: t("azure.fields.batch_size")
      }
    ),
    azureBatchSizeError && /* @__PURE__ */ React.createElement("span", null, " ", /* @__PURE__ */ React.createElement("strong", null, t("azure.fields.batch_size_error"))),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "azureWaitTime",
        name: "azureWaitTime",
        type: "number",
        value: azureWaitTime.value || azureWaitTime.defaultValue || "",
        min: "1",
        max: "30",
        onChange,
        required: true,
        help: t("azure.fields.wait_time_help"),
        label: t("azure.fields.wait_time")
      }
    ),
    azureWaitTimeError && /* @__PURE__ */ React.createElement("span", null, " ", /* @__PURE__ */ React.createElement("strong", null, t("azure.fields.wait_time_error"))),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
